import { forwardRef } from 'react';
import cn from 'classnames';

import ButtonProps, { ButtonControlType, ButtonControlTypeMap } from 'tailwind/components/Button/Button.types';
import { getComponentProps, getControlType } from 'tailwind/components/Button/Button.utility';
import {
  commonClasses,
  contentWrapperClasses,
  disabledClasses,
  hoverClasses,
  sizeClasses,
  variantClasses,
  visitedClasses
} from 'tailwind/components/Button/Button.classes';

const Button = forwardRef<HTMLButtonElement | HTMLAnchorElement, ButtonProps>((props: ButtonProps, ref) => {
  const {
    linkComponent,
    linkProps,
    allowVisited = false,
    children,
    tailIcon,
    href,
    isExternalLink = false,
    size = 'base',
    leadIcon,
    variant,
    disabled,
    type,
    ...forwardProps
  } = props;

  const controlType = getControlType({ href, isExternalLink, disabled });
  const componentProps = getComponentProps({ controlType, href, type, isExternalLink, disabled });

  const Component = ButtonControlTypeMap[controlType] ?? linkComponent;
  const linkComponentProps = controlType === ButtonControlType.link ? linkProps : {};

  return (
    <Component
      {...forwardProps}
      {...componentProps}
      {...linkComponentProps}
      ref={ref}
      className={cn(
        variantClasses[variant],
        allowVisited ? visitedClasses[variant] : '',
        sizeClasses[variant][size],
        hoverClasses[variant],
        disabledClasses[variant],
        commonClasses
      )}
    >
      <span className={contentWrapperClasses}>
        {leadIcon}
        {children}
        {tailIcon}
      </span>
    </Component>
  );
});

export default Button;
